import styled from 'styled-components'

export const Container = styled.div`
  padding: 20px;
  border-top: 1px solid ${props => props.theme.palette.general.greyLight};

  .row {
    > div {
      margin-right: 10px;

      input {
        border: 1px solid ${props => props.theme.palette.general.grey};
      }
    }
  }
`
